import { createReducer } from 'reduxsauce'
import { INITIAL_STATE } from './initialState'
import { AnalyticsTypes } from './Actions'
import RequestState from 'Enums/RequestState'

export const fetchTopCitiesLoading = (state) => {
  return {
    ...state,
    fetchTopCitiesRequestState: RequestState.LOADING,
  }
}

export const fetchTopCitiesSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTopCitiesRequestState: RequestState.SUCCEEDED,
    topCities: data,
  }
}
export const fetchTopCitiesFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTopCitiesRequestState: requestState,
  }
}

export const fetchPeakHourLoading = (state) => {
  return {
    ...state,
    fetchPeakHourRequestState: RequestState.LOADING,
  }
}

export const fetchPeakHourSuccess = (state, { data }) => {
  return {
    ...state,
    fetchPeakHourRequestState: RequestState.SUCCEEDED,
    peakHour: data,
  }
}
export const fetchPeakHourFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchPeakHourRequestState: requestState,
  }
}
export const fetchAverageDurationLoading = (state) => {
  return {
    ...state,
    fetchAverageDurationRequestState: RequestState.LOADING,
  }
}

export const fetchAverageDurationSuccess = (state, { data }) => {
  return {
    ...state,
    fetchAverageDurationRequestState: RequestState.SUCCEEDED,
    averageDuration: data,
  }
}
export const fetchAverageDurationFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchAverageDurationRequestState: requestState,
  }
}

export const fetchTopVouchersLoading = (state) => {
  return {
    ...state,
    fetchTopVouchersRequestState: RequestState.LOADING,
  }
}

export const fetchTopVouchersSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTopVouchersRequestState: RequestState.SUCCEEDED,
    topVouchers: data,
  }
}
export const fetchTopVouchersFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTopVouchersRequestState: requestState,
  }
}
export const fetchTopSitesLoading = (state) => {
  return {
    ...state,
    fetchTopSitesRequestState: RequestState.LOADING,
  }
}

export const fetchTopSitesSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTopSitesRequestState: RequestState.SUCCEEDED,
    topSites: data,
  }
}
export const fetchTopSitesFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTopSitesRequestState: requestState,
  }
}
export const fetchOverviewLoading = (state) => {
  return {
    ...state,
    fetchOverviewRequestState: RequestState.LOADING,
  }
}

export const fetchOverviewSuccess = (state, { data }) => {
  return {
    ...state,
    fetchOverviewRequestState: RequestState.SUCCEEDED,
    overview: data,
  }
}
export const fetchOverviewFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchOverviewRequestState: requestState,
  }
}
export const fetchTransactionsStatisticsLoading = (state) => {
  return {
    ...state,
    fetchTransactionsStatisticsRequestState: RequestState.LOADING,
  }
}

export const fetchTransactionsStatisticsSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTransactionsStatisticsRequestState: RequestState.SUCCEEDED,
    transactionsStatistics: data,
  }
}
export const fetchTransactionsStatisticsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTransactionsStatisticsRequestState: requestState,
  }
}
export const fetchUserSignupLoading = (state) => {
  return {
    ...state,
    fetchUserSignupRequestState: RequestState.LOADING,
  }
}

export const fetchUserSignupSuccess = (state, { data }) => {
  return {
    ...state,
    fetchUserSignupRequestState: RequestState.SUCCEEDED,
    userSignup: data,
  }
}
export const fetchUserSignupFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchUserSignupRequestState: requestState,
  }
}

export const fetchTopUsersLoading = (state) => {
  return {
    ...state,
    fetchTopUsersRequestState: RequestState.LOADING,
  }
}

export const fetchTopUsersSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTopUsersRequestState: RequestState.SUCCEEDED,
    topUsers: data,
  }
}
export const fetchTopUsersFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTopUsersRequestState: requestState,
  }
}
export const fetchUsersActivityLoading = (state) => {
  return {
    ...state,
    fetchUsersActivityRequestState: RequestState.LOADING,
  }
}

export const fetchUsersActivitySuccess = (state, { data }) => {
  return {
    ...state,
    fetchUsersActivityRequestState: RequestState.SUCCEEDED,
    usersActivity: { ...data },
  }
}
export const fetchUsersActivityFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchUsersActivityRequestState: requestState,
  }
}
export const fetchUsersStatisticsLoading = (state) => {
  return {
    ...state,
    fetchUsersStatisticsRequestState: RequestState.LOADING,
  }
}

export const fetchUsersStatisticsSuccess = (state, { data }) => {
  return {
    ...state,
    fetchUsersStatisticsRequestState: RequestState.SUCCEEDED,
    usersStatistics: { ...data },
  }
}
export const fetchUsersStatisticsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchUsersStatisticsRequestState: requestState,
  }
}

export const fetchEnergyChartLoading = (state) => {
  return {
    ...state,
    fetchEnergyChartRequestState: RequestState.LOADING,
  }
}

export const fetchEnergyChartSuccess = (state, { data }) => {
  return {
    ...state,
    fetchEnergyChartRequestState: RequestState.SUCCEEDED,
    energyChart: { ...data },
  }
}
export const fetchEnergyChartFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchEnergyChartRequestState: requestState,
  }
}
export const fetchTimeForFirstChargeLoading = (state) => {
  return {
    ...state,
    fetchTimeForFirstChargeRequestState: RequestState.LOADING,
  }
}

export const fetchTimeForFirstChargeSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTimeForFirstChargeRequestState: RequestState.SUCCEEDED,
    timeForFirstCharge: { ...data },
  }
}
export const fetchTimeForFirstChargeFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTimeForFirstChargeRequestState: requestState,
  }
}
export const fetchTimeBetweenTransLoading = (state) => {
  return {
    ...state,
    fetchTimeBetweenTransRequestState: RequestState.LOADING,
  }
}

export const fetchTimeBetweenTransSuccess = (state, { data }) => {
  return {
    ...state,
    fetchTimeBetweenTransRequestState: RequestState.SUCCEEDED,
    timeBetweenTrans: { ...data },
  }
}
export const fetchTimeBetweenTransFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTimeBetweenTransRequestState: requestState,
  }
}
export const fetchPaymentBreakdownLoading = (state) => {
  return {
    ...state,
    fetchPaymentBreakdownRequestState: RequestState.LOADING,
  }
}

export const fetchPaymentBreakdownSuccess = (state, { data }) => {
  return {
    ...state,
    fetchPaymentBreakdownRequestState: RequestState.SUCCEEDED,
    paymentBreakdown: { ...data },
  }
}
export const fetchPaymentBreakdownFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchPaymentBreakdownRequestState: requestState,
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [AnalyticsTypes.FETCH_TOP_CITIES_LOADING]: fetchTopCitiesLoading,
  [AnalyticsTypes.FETCH_TOP_CITIES_SUCCESS]: fetchTopCitiesSuccess,
  [AnalyticsTypes.FETCH_TOP_CITIES_FAIL]: fetchTopCitiesFail,
  [AnalyticsTypes.FETCH_PEAK_HOUR_LOADING]: fetchPeakHourLoading,
  [AnalyticsTypes.FETCH_PEAK_HOUR_SUCCESS]: fetchPeakHourSuccess,
  [AnalyticsTypes.FETCH_PEAK_HOUR_FAIL]: fetchPeakHourFail,
  [AnalyticsTypes.FETCH_AVERAGE_DURATION_LOADING]: fetchAverageDurationLoading,
  [AnalyticsTypes.FETCH_AVERAGE_DURATION_SUCCESS]: fetchAverageDurationSuccess,
  [AnalyticsTypes.FETCH_AVERAGE_DURATION_FAIL]: fetchAverageDurationFail,
  [AnalyticsTypes.FETCH_TOP_VOUCHERS_LOADING]: fetchTopVouchersLoading,
  [AnalyticsTypes.FETCH_TOP_VOUCHERS_SUCCESS]: fetchTopVouchersSuccess,
  [AnalyticsTypes.FETCH_TOP_VOUCHERS_FAIL]: fetchTopVouchersFail,
  [AnalyticsTypes.FETCH_TOP_SITES_LOADING]: fetchTopSitesLoading,
  [AnalyticsTypes.FETCH_TOP_SITES_SUCCESS]: fetchTopSitesSuccess,
  [AnalyticsTypes.FETCH_TOP_SITES_FAIL]: fetchTopSitesFail,
  [AnalyticsTypes.FETCH_OVERVIEW_LOADING]: fetchOverviewLoading,
  [AnalyticsTypes.FETCH_OVERVIEW_SUCCESS]: fetchOverviewSuccess,
  [AnalyticsTypes.FETCH_OVERVIEW_FAIL]: fetchOverviewFail,
  [AnalyticsTypes.FETCH_TRANSACTIONS_STATISTICS_LOADING]:
    fetchTransactionsStatisticsLoading,
  [AnalyticsTypes.FETCH_TRANSACTIONS_STATISTICS_SUCCESS]:
    fetchTransactionsStatisticsSuccess,
  [AnalyticsTypes.FETCH_TRANSACTIONS_STATISTICS_FAIL]:
    fetchTransactionsStatisticsFail,
  [AnalyticsTypes.FETCH_USER_SIGNUP_LOADING]: fetchUserSignupLoading,
  [AnalyticsTypes.FETCH_USER_SIGNUP_SUCCESS]: fetchUserSignupSuccess,
  [AnalyticsTypes.FETCH_USER_SIGNUP_FAIL]: fetchUserSignupFail,
  [AnalyticsTypes.FETCH_TOP_USERS_LOADING]: fetchTopUsersLoading,
  [AnalyticsTypes.FETCH_TOP_USERS_SUCCESS]: fetchTopUsersSuccess,
  [AnalyticsTypes.FETCH_TOP_USERS_FAIL]: fetchTopUsersFail,
  [AnalyticsTypes.FETCH_USERS_ACTIVITY_LOADING]: fetchUsersActivityLoading,
  [AnalyticsTypes.FETCH_USERS_ACTIVITY_SUCCESS]: fetchUsersActivitySuccess,
  [AnalyticsTypes.FETCH_USERS_ACTIVITY_FAIL]: fetchUsersActivityFail,
  [AnalyticsTypes.FETCH_USERS_STATISTICS_LOADING]: fetchUsersStatisticsLoading,
  [AnalyticsTypes.FETCH_USERS_STATISTICS_SUCCESS]: fetchUsersStatisticsSuccess,
  [AnalyticsTypes.FETCH_USERS_STATISTICS_FAIL]: fetchUsersStatisticsFail,
  [AnalyticsTypes.FETCH_ENERGY_CHART_LOADING]: fetchEnergyChartLoading,
  [AnalyticsTypes.FETCH_ENERGY_CHART_SUCCESS]: fetchEnergyChartSuccess,
  [AnalyticsTypes.FETCH_ENERGY_CHART_FAIL]: fetchEnergyChartFail,
  [AnalyticsTypes.FETCH_TIME_FOR_FIRST_CHARGE_LOADING]:
    fetchTimeForFirstChargeLoading,
  [AnalyticsTypes.FETCH_TIME_FOR_FIRST_CHARGE_SUCCESS]:
    fetchTimeForFirstChargeSuccess,
  [AnalyticsTypes.FETCH_TIME_FOR_FIRST_CHARGE_FAIL]:
    fetchTimeForFirstChargeFail,
  [AnalyticsTypes.FETCH_TIME_BETWEEN_TRANS_LOADING]:
    fetchTimeBetweenTransLoading,
  [AnalyticsTypes.FETCH_TIME_BETWEEN_TRANS_SUCCESS]:
    fetchTimeBetweenTransSuccess,
  [AnalyticsTypes.FETCH_TIME_BETWEEN_TRANS_FAIL]: fetchTimeBetweenTransFail,
  [AnalyticsTypes.FETCH_PAYMENT_BREAKDOWN_LOADING]:
    fetchPaymentBreakdownLoading,
  [AnalyticsTypes.FETCH_PAYMENT_BREAKDOWN_SUCCESS]:
    fetchPaymentBreakdownSuccess,
  [AnalyticsTypes.FETCH_PAYMENT_BREAKDOWN_FAIL]: fetchPaymentBreakdownFail,
})
